export default __webpack_public_path__ + "static/media/laruns_village.4c965606.jpg";